import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "./Slider.css";
const Slider = () => {
  return (
    <div className="slider">
      <Container>
        <Row>
          <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12}>
            <h1 className="slider-h1">
              Oferta legitymacji ucznia i&nbsp;nauczyciela w&nbsp;
              <span className="slider-span">stałej cenie</span> przez cały rok
              szkolny
            </h1>
            <p></p>
            <Button className="slider-button" href="#pricing">
              Legitymacja Ucznia
            </Button>
            <Button className="slider-button" href="#pricing">
              Służbowa Nauczyciela
            </Button>
          </Col>
          <Col
            className="text-center"
            xxl={6}
            xl={6}
            lg={12}
            md={12}
            sm={12}
            xs={12}
          >
            <Image
              src="./images/legitymacja-ucznia.png"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Slider;
